import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';

import { Link } from 'react-router-dom';
import {
  Card,
  MediaObject,
  Icon,
  Button
} from '@salesforce/design-system-react';
import { Chart } from '@mc-prime/einstein-ui-components';

import './AssetSummary.scss';

class AssetSummary extends Component {
  render() {
    const { formatMessage } = this.props.intl;
    const { chartRows, summary } = this.props;
    const chartConfig = {
      inner: 75,
      color: {
        column: ['type']
      },
      dimension: {
        column: ['type']
      },
      selectMode: 'single',
      valueType: 'none',
      centerValueType: 'none',
      showMeasureTitle: false,
      plots: [
        {
          column: ['sum']
        }
      ],
      theme: {
        base: 'wave'
      }
    };
    const rowsMetaData = [
      {
        column: 'type',
        type: 'dimension',
        label: formatMessage({ id: 'components.ecs.assetSummary.chart.label' }),
        valueLabels: {
          active: formatMessage({
            id: 'components.ecs.assetSummary.chart.valueLabels.active'
          }),
          expired: formatMessage({
            id: 'components.ecs.assetSummary.chart.valueLabels.expired'
          })
        },
        valueColors: {
          active: 'rgb(50, 144, 237)',
          expired: 'rgb(158, 82, 242)'
        }
      },
      {
        column: 'sum',
        type: 'measure',
        label: 'Assets',
        format: ['###,##', 1]
      }
    ];
    const tab = this.props.source || 'distribution';
    const cardHeader = (
      <MediaObject
        className="asset-summary-media"
        figure={<Icon category="standard" name="drafts" size="medium" />}
        body={
          <div className="slds-grid slds-grid_vertical-align-center">
            <h2>
              <FormattedMessage id="components.ecs.assetSummary.heading.title" />
            </h2>
            <nav className="card-header-right-nav">
              <Link to={{ pathname: `/assets/${tab}` }}>
                <Button variant="neutral">
                  <FormattedMessage id="components.ecs.assetSummary.heading.nav" />
                </Button>
              </Link>
            </nav>
          </div>
        }
      />
    );
    return (
      <Card className="asset-summary" header={cardHeader}>
        <div className="asset-aggregates slds-grid slds-gutters slds-grid_vertical-align-center">
          <div className="aggregate-values slds-col slds-grid slds-gutters slds-grid_vertical-align-center">
            <div className="pie-chart-container slds-col">
              {chartRows.length ? (
                <Chart
                  chartModule="sfdc-pie-chart"
                  modulePrefix="../"
                  rows={chartRows}
                  config={chartConfig}
                  rowsMetadata={rowsMetaData}
                  width={130}
                  height={130}
                />
              ) : null}
            </div>
            <div className="aggregate slds-col">
              <h2>
                <FormattedMessage id="components.ecs.assetSummary.labels.total" />
              </h2>
              <h3>
                <FormattedNumber value={summary.total || 0} />
              </h3>
            </div>
            <div className="aggregate aggregate-active slds-col">
              <h2>
                <FormattedMessage id="components.ecs.assetSummary.labels.active" />
              </h2>
              <h3>
                <FormattedNumber value={summary.active || 0} />
              </h3>
            </div>
            <div className="aggregate aggregate-expired slds-col">
              <h2>
                <FormattedMessage id="components.ecs.assetSummary.labels.expired" />
              </h2>
              <h3>
                <FormattedNumber value={summary.expired || 0} />
              </h3>
            </div>
          </div>
          <div className="expiring-assets slds-col">
            <div className="expire-summary slds-grid slds-grid_vertical-align-center slds-grid_align-space">
              <h2 className="slds-col">
                <FormattedMessage id="components.ecs.assetSummary.labels.expiring7days" />
              </h2>
              <h3 className="slds-col">
                <FormattedNumber value={summary.expiring_7_days || 0} />
              </h3>
            </div>
            <div className="expire-summary slds-grid slds-grid_vertical-align-center slds-grid_align-space">
              <h2 className="slds-col">
                <FormattedMessage id="components.ecs.assetSummary.labels.expiring30days" />
              </h2>
              <h3 className="slds-col">
                <FormattedNumber value={summary.expiring_30_days || 0} />
              </h3>
            </div>
          </div>
          <div className="asset-classes slds-col">
            <div className="classes-number">
              <h2>
                <FormattedMessage id="components.ecs.assetSummary.labels.assetClasses" />
              </h2>
              <h3>
                <FormattedNumber value={summary.types || 0} />
              </h3>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

AssetSummary.propTypes = {
  actions: PropTypes.object,
  summary: PropTypes.object,
  location: PropTypes.object,
  chartRows: PropTypes.array,
  source: PropTypes.oneOf(['distribution', 'settings'])
};

export default injectIntl(AssetSummary);
